import { ChartNames } from "store/slice/charts/chartsSlice.types";
import { TUserRole } from "types/globals";

export const SAVE_SEARCH = "currentSearch";
export const REDIRECT_PACE = "/pace/setup";
export const REDIRECT_LD = "/leadership-dynamics/search";
export const REDIRECT_SELECT_HUB = "/choose-your-hub";
export const APP_LANG = "EN";
export const PACE_LABS_CHARTS = ["LD5", "LD7", "LD4", "LD3", "LD2", "LD8"] as ChartNames[];
export const PEERS_LIMIT = 6;
export const USERS_ADMIN_LIMIT = 5;

export const LOCATIONS = {
    INTERNATIONAL: "International",
    LOCAL: "local",
};

// Temporary list of fuctions while we wait for the API Endpoint
export const functionsList = [
    { id: 1, label: "TECHNOLOGY", name: "Technology" },
    { id: 2, label: "NON_EXECUTIVE", name: "Non-Executive" },
    { id: 3, label: "FINANCE", name: "Finance" },
    { id: 4, label: "MARKETING", name: "Marketing" },
    { id: 5, label: "LEADERSHIP", name: "Leadership" },
    { id: 6, label: "HR", name: "Human Resources" },
    { id: 7, label: "REVENUE_SALES", name: "Sales" },
    { id: 8, label: "MANAGEMENT", name: "Management" },
    { id: 9, label: "OPERATIONS", name: "Operations" },
    { id: 10, label: "NON_EXECUTIVE_LEADERSHIP", name: "Non-Executive Leadership" },
];

export const initialPagination = {
    hits: 0,
    pages: 0,
    page_size: 0,
    page_no: 0,
};

export const initialPaginationOS = {
    results_total: 0,
    page_total: 0,
    page_size: 0,
    page: 0,
};

export const allUserRoles: TUserRole[] = [
    {
        id: "placeholder",
        label: "Select Role to Add",
    },
    {
        id: "ADMIN",
        label: "Admin",
        description: "Full permissions on platform, can assign roles.",
    },
    {
        id: "VIEW_EDIT",
        label: "View & Edit",
        description: "Can view/edit/create content.",
    },
    {
        id: "VIEW_ONLY",
        label: "View Only",
        description: "Can only view the platform.",
    },
    {
        id: "PROFILE",
        label: "Profile Only",
        description: "No access to product, only you can see their profile.",
    },
];
